// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/toolStepLabel.test.ts

/**
 * The warhol tools whose chip names are house copy, by the slug on `step.tool`.
 *
 * `displayName` is English by construction: warhol's `runtime/live_steps.py`
 * and christo's `warholToolDisplayName` either humanize the slug ("Write plan")
 * or copy `DISPLAY_NAMES`, and neither knows the reader's language. The chip is
 * the one place that turns the slug into words, the same split
 * `ask-v2/rail/checkNames.ts` makes for check names.
 */
const TOOL_NAME_KEY: Record<string, string> = {
  write_plan: "writePlan",
  intents_from_drafts: "intentsFromDrafts",
  load_capability: "loadSkill",
  run_python: "runPython",
  ocr_pages: "ocrPages",
};

type NamedStep = {
  tool?: string | null;
  displayName?: string | null;
  statusName?: string | null;
};

/**
 * A tool step's chip name: the status the backend set, else the house copy for
 * a known tool, else the backend's display name.
 *
 * why the status first: a backend that sets one words the step for this very
 * call ("Searching the spec"), which a name for the tool cannot.
 */
export function toolStepLabel(
  step: NamedStep,
  t: (key: string) => string,
): string {
  if (step.statusName) return step.statusName;
  const key = step.tool ? TOOL_NAME_KEY[step.tool] : undefined;
  if (key) return t(`agentSteps.toolNames.${key}`);
  return step.displayName ?? "";
}
